import { isEmpty } from 'lodash';
import report, { ChequeDetailReportFilter } from '../../../apis/report';
import { ChequeDetailReportData } from '../types';
import moment from 'moment';

export const fetchChequeDetailReportData = async ({
  chequeStatus,
  collectionType,
  academicYear,
  grade
}: ChequeDetailReportFilter) => {
  const chequeDetailReportData: any[] = [];
  const perPage = 300;
  let pageNo = 1;
  const BATCH_SIZE = 3;
  let hasMoreData = true;

  do {
    const pagePromises = [];
    for (let i = 0; i < BATCH_SIZE; i++) {
      pagePromises.push(
        report.fetchChequeDetailReport({
          chequeStatus,
          collectionType,
          grade,
          academicYear,
          page: pageNo + i,
          perPage
        })
      );
    }

    const batchResults = await Promise.all(pagePromises);

    let foundEmpty = false;
    batchResults.forEach((result) => {
      if (isEmpty(result)) {
        foundEmpty = true;
        return;
      }
      chequeDetailReportData.push(...(result as any));
    });

    if (foundEmpty) {
      hasMoreData = false;
    } else {
      pageNo += BATCH_SIZE;
    }
  } while (hasMoreData);

  return chequeDetailReportData;
};

export const transformChequeDetailReportData = (
  chequeDetailReportData: ChequeDetailReportData[]
) => {
  const DATE_FORMAT = 'DD-MMM-YYYY';
  const result: any = [];
  let srNo = 1;
  chequeDetailReportData.forEach((record: ChequeDetailReportData) => {
    result.push({
      'Sr. No.': srNo,
      'Student Name': record.studentDetails?.name || '',
      'Enrollment No.': record.studentDetails.enrollmentNo,
      'Student Status': record.studentDetails.status,
      'Academic Year': record.session || '',
      Class: record.grade || '',
      Section: record.division || '',
      'Receipt No.': record.receiptNo || '',
      Status: record.status || '',
      'Fee Cancelled': 'false',
      'Cheque No.': record.chequeNo || '',
      'Date of Issue': record.paymentDate
        ? moment(record.paymentDate).format(DATE_FORMAT)
        : '',
      Amount: record.amount || '',
      'Bank Name': record.bank,
      'Fee Deposited Upto': record.feeDepositedUpto
        ? moment(record.feeDepositedUpto).format(DATE_FORMAT)
        : '',
      'Fee Deposit Date': record.feeDepositDate
        ? moment(record.feeDepositDate).format(DATE_FORMAT)
        : '',
      'Cheque Deposit Date': record.chequeDepositDate,
      'Cheque Cleared Date': record.chequeClearedDate,
      'Cheque Bounced Date': record.chequeBouncedDate,
      Remarks: record.remarks || '',
      'Collection Type': record.particulars
    });
    srNo++;
  });

  return result;
};
